import { logger } from '@/lib/logger';

export const logSelectNationalityFPTI = ({
  country,
}: {
  country: string;
}): void => {
  logger.fpti('weasley_process_nationality_change', {
    nationality_country: country,
    state_name: 'signup',
    transition_name: 'process_nationality_change',
  });
};

export const logNationalityTextOnRenderFPTI = ({
  country,
}: {
  country: string;
}): void => {
  logger.fpti('weasley_change_nationality', {
    nationality_country: country,
    state_name: 'signup',
    transition_name: 'prepare_collapse_nationality',
  });
};
